import React, { useEffect } from 'react';

import { FormGroup, Stack, Switch, Typography } from '@mui/material';

import { useAppState } from '../../context/AppState';
import { useIntelState } from '../../context/IntelState';
import RestUtilities from '../../services/RestUtilities';

export default function ServerSelector() {
  const { intelState, intelDispatch } = useIntelState();
  const { appState } = useAppState();
  useEffect(() => {
    const fetchData = async () => {
      const response = await RestUtilities.get(
        `Data/v1/RaceCombos/${intelState.server}`
      );
      if (response.ok) {
        intelDispatch({
          type: 'SET_RACES',
          payload: response.content,
          server: intelState.server,
        });
      }
    };
    if (
      (intelState.server === 1 && !intelState.racesWol) ||
      (intelState.server === 2 && !intelState.racesGen)
    ) {
      fetchData();
    }
  }, [
    intelDispatch,
    intelState.racesGen,
    intelState.racesWol,
    intelState.server,
  ]);

  const handleChange = () => {
    intelDispatch({
      type: 'SET_SERVER',
      payload: intelState.server === 1 ? 2 : 1,
    });
  };
  if (appState.isDev) return null;
  return (
    <FormGroup>
      <Stack direction='row' spacing={1} alignItems='center'>
        <Typography variant='body2' color='primary'>
          Wol
        </Typography>
        <Switch
          name='server-selector'
          checked={intelState.server === 2}
          onChange={handleChange}
          size='small'
          color={intelState.server === 1 ? 'primary' : 'secondary'}
        />
        <Typography variant='body2' color='secondary'>
          Gen
        </Typography>
      </Stack>
    </FormGroup>
  );
}
